export default __webpack_public_path__ + "static/media/high-five-pana.a98f2ddc.png";